import { request } from './helpers/request'

export const loadInvitation = data =>
  request({
    method: 'GET',
    url: `/users/invitation/accept/${data.invitationToken}`
  })
    .then(response => {
      if (response.status === 200) {
        return response.json().then(json => {
          return Promise.resolve(json)
        })
      }

      return Promise.reject(new Error())
    })
    .catch(error => {
      throw error
    })
